<template>
  <div class="profile-business-tab no-scrollbar" :class="theme">
    <!-- <div style="height: 10px" /> -->
    <!-- <div class="no-scrollbar"> -->
    <!-- <div
      class="tabs is-fullwidth is-boxed"
      :class="theme"
      style="margin-bottom: 0"
    >
      <ul class="trips-tabs has-text-weight-medium">
        <li :class="{ 'is-active': tab === 'roles' }" @click="setTab('roles')">
          <a>{{ $t("profile.roles") }}</a>
        </li>
        <li :class="{ 'is-active': tab === 'jobs' }" @click="setTab('jobs')">
          <a>{{ $t("profile.jobs") }}</a>
        </li>
      </ul>
    </div> -->

    <!-- Jobs tab -->
    <!-- <div v-if="isJobs">
      <UpcomingJobsList />
      <br />
    </div> -->

    <!-- Roles tab -->
    <!-- <div v-if="isRoles"> -->
    <div :key="z" style="margin-top: 2px">
      <!-- workerRoles -->
      <div v-if="!workerRoles.length">
        <div class="card">
          <div class="card-content">Click + Button to add a work role</div>
        </div>
      </div>

      <div class="header">
        {{ $t("Business Roles") }}
      </div>
      <div class="card" v-for="(r, i) in workerRoles" :key="r.id">
        <div class="card-content">
          <div class="content has-text-left">
            <i class="fa fa-briefcase"></i>&nbsp;&nbsp;
            <a :href="'/business_profile/' + r.business_id">{{
              r.business.name
            }}</a>
            -
            <a>{{ r.workflow_name }}</a>
            -
            <a>{{ r.role_name }}</a>
            <div style="margin-top: 6px">
              <span v-if="r.state === 'working'" class="button is-danger" @click="stopWork(r)">
                <i class="fa fa-cog fa-spin" v-if="r.state === 'working'" />
                &nbsp;{{ $t("transport.working") }}
              </span>
              <span v-else class="button is-primary" @click="startWork(r)">
                <i class="fa fa-running" />
                &nbsp;{{ $t("profile.start-work") }} </span>&nbsp;
              <span class="button" @click="shareWorkerRole(r)">
                <i class="fa fa-share-alt"></i>
                &nbsp;{{ $t("invite") }} </span>&nbsp;
              <span class="button is-danger" :class="{ 'is-outlined': !isStartURL(r) }" @click="toggleStartURL(r)">
                <i class="fa fa-heart" />
              </span>

              <a class="button is-rounded is-pulled-right" style="padding: 9px">
                <i v-if="r.role_name === 'Driver'" class="fa fa-pencil-alt has-text-success" @click="editRole(r)" />
                <i v-else-if="isSuperUser()" class="fa fa-pencil-alt has-text-grey" @click="editRole(r)" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div style="margin: 16px 10px">
        <i class="button fa fa-plus is-fullwidth" @click="addBusinessRole" />
      </div>
    </div>

    <FavoritesList />

    <button class="button is-warning is-rounded" @click="updateRoles(true)" v-show="$store.getters.isLoggedIn">
      {{ $t("profile.roles-update") }}
    </button>
    <!-- </div> -->
    <br />
    <br />
    <AddRoleModal />
    <!-- <EditRoleModal :role="selectedRole" /> -->
  </div>
</template>

<script>
import EventBus from "../eventBus";
import AddRoleModal from "@/components/AddRoleModal.vue";
// import EditRoleModal from "@/components/EditRoleModal.vue";
import FavoritesList from "@/components/FavoritesList.vue";
// import UpcomingJobsList from "@/components/UpcomingJobsList.vue";

export default {
  components: {
    AddRoleModal,
    // EditRoleModal,
    FavoritesList,
    // UpcomingJobsList,
  },
  data() {
    return {
      // selectedRole: null,
      tab: "roles",
      z: 0,
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    isRoles() {
      if (this.tab === "roles") return true;
      return false;
    },
    isJobs() {
      if (this.tab === "jobs") return true;
      return false;
    },
    workerRoles() {
      return this.$store.getters.getWorkerRoles;
    },
  },
  mounted() {
    EventBus.$on("SET_BUSINESS_TAB", (tab) => (this.tab = tab));
  },
  methods: {
    checkStartURL() {
      setTimeout(() => {
        var arr = this.workerRoles.filter((r) => r.data.start_url);
        if (arr.length === 0) {
          this.infoToast("No favorite role is set.");
        } else if (arr.length === 1) {
          var msg = `Your favorite role is ${arr[0].role_name}`;
          this.successToast(msg);
        } else {
          msg = `You have ${arr.length} favorite roles.<br>You should only have 1.`;
          this.warningToast(msg);
        }
      }, 2000);
    },
    isStartURL(r) {
      return r.data.start_url;
    },
    startURL(roleName) {
      switch (roleName) {
        case "Superuser":
          return "super_ops";
        case "Commerce Agent":
          return "ecommerce";
        case "Driver":
        case "Delivery Driver":
          return "driver";
        default:
          return "ecommerce";
      }
    },
    toggleStartURL(r) {
      if (r.data.start_url) {
        r.data.start_url = null;
      } else {
        r.data.start_url = this.startURL(r.role_name); // "ecommerce";
      }
      var payload = { id: r.id, data: r.data };
      var loader = this.loadingDots("blue");
      this.$store
        .dispatch("updateRoleData", payload)
        .then((res) => {
          this.console("updateRoleData", res);
          this.updateRoles(true);
          this.checkStartURL();
          this.z += 1;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    setTab(tab) {
      this.tab = tab;
    },
    addBusinessRole() {
      this.updateRoles(false);
      this.displayModal(".add-role-modal");
    },
    startWork(r) {
      this.console("startWork for role", r);
      var driverRoles = ["Driver", "Delivery Driver"];
      if (driverRoles.includes(r.role_name)) this.goto("/driver");
      if (r.role_name === "Dispatcher") this.goto("/fleet_dispatcher");
      if (r.role_name === "Commerce Agent") this.goto("/ecommerce");
      if (r.role_name === "Superuser") this.goto("/super_ops");
      // this.goto("/tuktuk?start_work=true");
    },
    stopWork(r) {
      return this.startWork(r);
      // var driverRoles = ["Driver", "Delivery Driver"];
      // if (driverRoles.includes(r.role_name)) this.goto("/driver");
      // if (r.role_name === "Dispatcher") this.goto("/fleet_dispatcher");
    },
    parsePhoneNumber(raw) {
      if (raw[0] === "0") {
        return `+66${raw.substring(1, raw.length)}`; // probably local thai number like 0909588716
      }
      if (raw.substring(0, 4) === "+660") {
        return `+66${raw.substring(4, raw.length)}`; // thai number with extra 0
      }
      if (raw[0] === "+") {
        return raw; // could be correct international number
      }
      return null;
    },
    editRole(r) {
      console.log("editRole", r);
      // this.selectedRole = r;
      // this.displayModal(".edit-role-modal");
      if (r.role_name === "Driver") {
        EventBus.$emit("EDIT_ROLE_MODAL", r);
      } else {
        EventBus.$emit("ROLE_EDIT_JSON_MODAL", r);
      }
    },
    shareWorkerRole(r) {
      this.$swal({
        title: this.$t("profile.share-business-role"), //"Share Business Role",
        text: `${r.business.name} - ${r.workflow_name} - ${r.role_name}`,
        input: "text", //"number",
        inputValue: "+66",
        showCancelButton: false,
        inputValidator: (val) => {
          if (!val || val.length < 10) return "You must enter a mobile number!";
          if (!this.parsePhoneNumber(val)) return "Invalid phone number!";
          this.$store
            .dispatch("createRole", {
              phone_number: this.parsePhoneNumber(val),
              business_id: r.business_id,
              workflow_id: r.workflow_id,
              workflow_name: r.workflow_name,
              role_type: r.role_type,
              role_name: r.role_name,
            })
            .then(() => this.success())
            .catch((err) => this.apiError(err));
        },
      });
    },
    deleteWorkerRole(r) {
      var loader = this.loadingDots();
      this.$store
        .dispatch("deleteRole", r.id) // should soft delete
        .then((res) => {
          this.console(res);
          this.$store.dispatch("getRoles", this.$store.state.user.id);
        })
        .catch((err) => console.error(err))
        .finally(() => loader.hide());
    },
    removeWorkerRole(r) {
      if (this.$store.getters.isSuperUser) {
        if (r.state === "working") {
          this.warningAlert("You must stop working before deleting your role!");
          return;
        }
        this.deleteWorkerRole(r); // only delete role automatically if superuser
        return;
      }
      this.$swal({
        html: `<strong>${r.business.name} - ${r.workflow_name} - ${r.role_name}</strong>
        <br><br>Role removal request submitted<br><br>Please wait for confirmation`,
        showConfirmButton: true,
        type: "success",
      });
      this.$store
        .dispatch("sendEmail", {
          role: JSON.stringify(r),
          business_name: r.business_name,
          workflow_name: r.workflow_name,
          role_name: r.role_name,
          role_id: r.id,
          user_id: this.$store.state.user.id,
          mobile: this.$store.getters.phoneNumber,
          name: this.$store.getters.realName,
          type: "business role removal request",
          app: process.env.VUE_APP_TITLE,
        })
        .then((res) => this.console(res))
        .catch((err) => console.error(err));
    },
  },
};
</script>

<style scoped>
.profile-business-tab {
  overflow: auto;
  height: calc(100vh - 180px);
}

.header {
  text-align: left;
  padding: 4px 12px;
  opacity: 0.6;
  font-weight: 500;
}

.card {
  box-shadow: initial;
  margin-bottom: 6px;
}

hr {
  margin: 0 0;
}

.field-name {
  margin-bottom: 0;
  line-height: 0pt;
  font-size: 0.8em;
  opacity: 0.6;
}

/* .card {
  margin-top: 10px;
} */
.card-content {
  padding: 12px;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.dark {
  background-color: rgb(59, 59, 59);
  color: white;
}

.dark .card {
  background-color: #1f1b2494;
  color: lightslategrey;
}

.dark hr {
  background-color: rgba(255, 255, 255, 0.15);
}

/* .dark li a {
  color: white;
}
li.is-active {
  color: blue !important;
} */
</style>